import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const defaultConfig = {
  whatsapp_number: '56975294340',
  whatsapp_display: '+56 9 7529 4340',
};

const SiteConfigContext = createContext(defaultConfig);

export const useSiteConfig = () => useContext(SiteConfigContext);

export const SiteConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(defaultConfig);

  useEffect(() => {
    axios.get(`${API}/public/site-settings`).then(r => {
      if (r.data && r.data.whatsapp_number) {
        setConfig(prev => ({ ...prev, ...r.data }));
      }
    }).catch(() => {});
  }, []);

  return (
    <SiteConfigContext.Provider value={config}>
      {children}
    </SiteConfigContext.Provider>
  );
};

// Helper to build WhatsApp URL
export const getWhatsAppUrl = (number, message = '') => {
  const clean = number.replace(/[^0-9]/g, '');
  return `https://wa.me/${clean}${message ? `?text=${encodeURIComponent(message)}` : ''}`;
};
